import { render, staticRenderFns } from "./ChannelSessionsBlock.vue?vue&type=template&id=268eae24&scoped=true"
import script from "./ChannelSessionsBlock.vue?vue&type=script&lang=js"
export * from "./ChannelSessionsBlock.vue?vue&type=script&lang=js"
import style0 from "./ChannelSessionsBlock.vue?vue&type=style&index=0&id=268eae24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268eae24",
  null
  
)

export default component.exports